import { Component, ViewChild } from '@angular/core';
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
import { LoginService } from 'app/services/login/login.service';

@Component({
  selector: 'app-listado-empresas',
  templateUrl: './listado-empresas.component.html',
  styleUrls: ['./listado-empresas.component.css']
})
export class ListadoEmpresasComponent{


  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  pageSizeOptions = [10,20,30,50,100,200];
  docNegociables:any = [];
  loading:boolean=false;
  displayedColumns: string[] = 
            ['Num_Doc_Identificacion','Razon_Social','Nombre_Comercial','Estado'];
  dataSource = new MatTableDataSource( this.docNegociables) ;


  constructor( private router :Router,private loginService:LoginService) {
  
   }
  
  test(valor?:string) {
    this.loginService.clickGuard = true;

    this.router.navigate(['/empresas/contactos/',valor])
  }

}
